import axios from "axios";
import { API_URL } from "./api";

export const baseURL = `${API_URL}/api`;

const api = axios.create({
  baseURL: baseURL,
});

// ✅ ADD THIS INTERCEPTOR
api.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");

  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }

  return config;
});

export default api;